import React from "react";

export default function SearchBox({ value, onChange, placeholder }) {
  return (
    <input
      className="lo-search"
      type="search"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      aria-label="Search orders"
    />
  );
}
